// Same as backend expected
export enum CancelReason {
	CUSTOMER = 'Customer',
	VENUE_ERROR = 'Venue Error',
	NO_SHOW = 'No Show',
	CUSTOMER_REQUESTED = 'Customer Requested',
	OTHER = 'Other',
}
